import {Button} from "antd";
import React, {useState} from "react";
import useUserContext from "../../hooks/useUserContext";
import useToast from "../../hooks/useToast";
import {ToastSkin} from "../../context/ToastContext";
import "./shop-consent-policy.css";
import {updateShopConsent} from "../../api/updateShopConsent";
import ConsentPolicySelector from "./ConsentPolicySelector";

const ShopConsentPolicy = () => {
    const { selectedDomain } = useUserContext();
    const { showToast } = useToast();
    const [consentPolicy, setConsentPolicy] = useState<number | null>(null);


    const onSubmitConsentPolicy = async () => {
        if(selectedDomain && consentPolicy !== null) {
            const response = await updateShopConsent(selectedDomain, consentPolicy);
            if(!response.data || response.data.errorMessage) {
                showToast({ skin: ToastSkin.error, text: 'Failed to update shop consent policy' });
            } else {
                showToast({ skin: ToastSkin.approval, text: "Your shop's consent policy has been successfully updated." });
            }
        }
    }

    return (
        <div className="sub-section shop-consent-policy">
            <div className="sub-section-title">
                Shop Consent Policy
            </div>
            <div className="sub-section-description">
                This section allows you to choose how to recover abandoned checkouts based on client consent. Consent is necessary to ensure compliance with privacy laws and avoid potential legal issues. While recovering all checkouts without consent might be more effective in terms of volume, it carries risks of violating regulations. Selecting an option based on client consent helps balance effectiveness with compliance, ensuring you stay within legal boundaries while optimizing recovery efforts.
            </div>
            <div className="consent-policy sub-section-content">
                <ConsentPolicySelector consentPolicy={consentPolicy} setConsentPolicy={setConsentPolicy} />
                <div className="buttons">
                    <Button type="primary" size="large" onClick={onSubmitConsentPolicy}>Update Consent Policy</Button>
                </div>
            </div>
        </div>
    )
}

export default ShopConsentPolicy;